// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.track-status {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 14px 16px;
  background: var(--surface);
  border: 1px solid var(--border);
  border-radius: var(--radius);
  box-shadow: var(--shadow-xs);
}

.track-status strong {
  display: block;
  font-family: var(--font-display);
  font-size: 0.95rem;
  color: var(--text);
}

.track-status span {
  font-size: 0.83rem;
  color: var(--muted);
}

.track-dot {
  flex-shrink: 0;
  width: 11px;
  height: 11px;
  border-radius: 50%;
  background: var(--muted2);
}

.track-live {
  border-left: 4px solid #16a34a;
}

.track-live .track-dot {
  background: #16a34a;
  box-shadow: 0 0 0 4px rgba(22, 163, 74, 0.18);
  animation: track-pulse 1.6s ease-in-out infinite;
}

@keyframes track-pulse {
  0%,
  100% {
    box-shadow: 0 0 0 3px rgba(22, 163, 74, 0.18);
  }
  50% {
    box-shadow: 0 0 0 7px rgba(22, 163, 74, 0.08);
  }
}

@media (prefers-reduced-motion: reduce) {
  .track-live .track-dot {
    animation: none;
  }
}
`, "",{"version":3,"sources":["webpack://./src/app/order/TrackingPanel.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,0BAA0B;EAC1B,+BAA+B;EAC/B,4BAA4B;EAC5B,4BAA4B;AAC9B;;AAEA;EACE,cAAc;EACd,gCAAgC;EAChC,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,mBAAmB;EACnB,6CAA6C;EAC7C,gDAAgD;AAClD;;AAEA;EACE;;IAEE,6CAA6C;EAC/C;EACA;IACE,6CAA6C;EAC/C;AACF;;AAEA;EACE;IACE,eAAe;EACjB;AACF","sourcesContent":[".track-status {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 14px 16px;\n  background: var(--surface);\n  border: 1px solid var(--border);\n  border-radius: var(--radius);\n  box-shadow: var(--shadow-xs);\n}\n\n.track-status strong {\n  display: block;\n  font-family: var(--font-display);\n  font-size: 0.95rem;\n  color: var(--text);\n}\n\n.track-status span {\n  font-size: 0.83rem;\n  color: var(--muted);\n}\n\n.track-dot {\n  flex-shrink: 0;\n  width: 11px;\n  height: 11px;\n  border-radius: 50%;\n  background: var(--muted2);\n}\n\n.track-live {\n  border-left: 4px solid #16a34a;\n}\n\n.track-live .track-dot {\n  background: #16a34a;\n  box-shadow: 0 0 0 4px rgba(22, 163, 74, 0.18);\n  animation: track-pulse 1.6s ease-in-out infinite;\n}\n\n@keyframes track-pulse {\n  0%,\n  100% {\n    box-shadow: 0 0 0 3px rgba(22, 163, 74, 0.18);\n  }\n  50% {\n    box-shadow: 0 0 0 7px rgba(22, 163, 74, 0.08);\n  }\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .track-live .track-dot {\n    animation: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
